import React from 'react';
// components
import LoadingIcon from './LoadingIcon';
const SectionLoader = ({ height }) => (
  <div style={{ height }} className="modal-loader-wrapper">
    <LoadingIcon />
  </div>
);
export default SectionLoader;
